



























































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Ajax from "@/lib/ajax";
import Order from "@/store/entities/booking/order";
import moment from "moment";
import User from "@/store/entities/user";
import regex from "@/lib/regex";

class ExtendInfo {
  notice: string = "";
  cancelNotice: string = "";
  reserveFlow: string = "";
  reserveNotice: string = "";
  refundReason: string = "";
  creator: User = null;
  flatOffer: any = null;
}
class postData {
  id: number = 0;
  phoneNumber: string = "";
}

@Component({
  components: {},
})
export default class OrderDetail extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  @Prop({
    type: Object,
    default: () => {
      return new Order();
    },
  })
  order: Order;
  extendInfo: ExtendInfo = new ExtendInfo();
  postData: postData = new postData();
  moment = moment;
  phoneNumber: string = "";
  teeTime: string | any = "";

  spinShow: boolean = false;
  get orderStatesDic() {
    return this.$store.state.common.orderStatesDic;
  }
  get dateLabel() {
    if ([4, 5, 6].indexOf(this.order.orderState) == -1) {
      return "订单日期";
    } else {
      return "申请退款日期";
    }
  }
  get orderTypeDic() {
    return this.$store.state.common.orderTypesDic;
  }
  get isAdmin() {
    return (
      this.$store.state.session.user && this.$store.state.session.user.isAdmin
    );
  }
  async changeDateTime() {
    if (!this.teeTime) {
      this.$Message.error({
        content: "请选择打球时间",
      });
      return;
    }
    await Ajax.put("/api/services/app/Order/UpdateTeeTime", {
      id: this.order.id,
      teeTime: this.teeTime,
    }).then((res) => {
      this.$Message.success({
        content: "修改打球时间成功",
      });
      this.$emit("input", false);
      this.$emit("getPage");
    });
  }
  getTime(value) {
    return Util.int2time(value);
  }
  async datetimeChange(e) {
    if (e) {
      this.teeTime = e;
    }
  }
  sendRule = {
    phoneNumber: [
      {
        required: true,
        message: "请输入手机号",
        trigger: "blur",
      },
      {
        pattern: /^1[3456789]\d{9}$/,
        message: "手机号格式不正确",
        trigger: "blur",
      },
    ],
  };
  /**
   * @description:发送待付款短信通知
   */
  sendToUser() {
    if (this.order.id) {
      if (!this.postData.phoneNumber) {
        this.$Message.error({
          content: "请输入手机号",
        });
        return;
      }
      if (!regex.phone.test(this.postData.phoneNumber)) {
        this.$Message.error({
          content: "手机号格式不正确",
        });
        return;
      }
      this.$Modal.confirm({
        title: this.L("Tips"),
        content: "确定发送短信通知吗",
        okText: this.L("Yes"),
        cancelText: this.L("No"),
        onOk: async () => {
          await this.sendNotice();
        },
      });
    }
  }
  async sendNotice() {
    this.postData.id = this.order.id;
    await this.$store
      .dispatch({
        type: "order/SendSmsToUser",
        data: this.postData,
      })
      .then((res) => {
        if (res && res.data) {
          this.$Message.success({
            content: "发送成功",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  getSourceType(type) {
    if (type == 0) {
      return "小程序";
    } else if (type == 1) {
      return "Pc";
    } else if (type == 2) {
      return "App";
    } else if (type == 3) {
      return "H5";
    } else if (type == 4) {
      return "其他";
    }
  }
  closeTable() {
    this.$emit("input", false);
    this.$emit("getPage");
  }
  async changeAmount() {
    this.spinShow = true;
    await Ajax.put("/api/services/app/User/UpdateUserAmount", {
      userId: this.extendInfo.creator.id,
      amount: this.extendInfo.creator.amount,
      name: this.extendInfo.creator.name,
    });
    this.spinShow = false;
  }
  get addPrice() {
    return (reduction, vipReduction) => {
      return reduction + vipReduction;
    };
  }
  save() {
    this.$emit("input", false);
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.extendInfo = new ExtendInfo();
      this.$emit("input", value);
    } else {
      if (this.order.id) {
        let reponse = await Ajax.get(
          "/api/services/app/Order/GetOrderExtendInfo?id=" + this.order.id
        );
        this.extendInfo = reponse.data.result;
      }
    }
  }
}
